module.exports = __webpack_public_path__ + "img/392.bbfe5a9b.svg";